import { RouterProvider as HeroUIRouterProvider } from "@heroui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type PropsWithChildren } from "react";
import { useHref, useNavigate } from "react-router-dom";

import { AuthProvider } from "@/features/auth/AuthProvider";
import { WorkspaceProvider } from "@/features/workspaces/WorkspaceProvider";

export function AppProviders({ children }: PropsWithChildren) {
  const navigate = useNavigate();
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: { queries: { retry: false } } }),
  );

  return (
    <HeroUIRouterProvider navigate={navigate} useHref={useHref}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <WorkspaceProvider>{children}</WorkspaceProvider>
        </AuthProvider>
      </QueryClientProvider>
    </HeroUIRouterProvider>
  );
}
